
class VideoPlayer {
  constructor(mobileVideoSelector, desktopVideoSelector, playButtonSelector, headlineSelector) {
    this.mobileVideos = document.querySelectorAll(mobileVideoSelector);
    this.desktopVideos = document.querySelectorAll(desktopVideoSelector);
    this.playButton = document.getElementById(playButtonSelector);
    this.headlineVideos = document.querySelectorAll(headlineSelector);
    this.init();
  }

  init() {
    this.mobileVideos.forEach((video, index) => {
      const container = video.closest('.video-container-mobile');
      const muteBtn = container.querySelector('.mute-btn');
      const unmuteBtn = container.querySelector('.unmute-btn');

      if (video.muted) {
        muteBtn.classList.remove('hidden');
        unmuteBtn.classList.add('hidden');
      } else {
        muteBtn.classList.add('hidden');
        unmuteBtn.classList.remove('hidden');
      }

      muteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleMuteMobileForContainer(container);
      });
      unmuteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleMuteMobileForContainer(container);
      });

      const overlay = container.querySelector('.video-overlay');
      const soundButtons = document.querySelectorAll('.sound-buttons');
      if (overlay) {
        overlay.addEventListener('click', () => {
          overlay.style.display = 'none';
          soundButtons.forEach((sb) => {
            sb.style.visibility = 'visible';
          });
          this.playMobileVideo(video, index);
        });
      }

      video.addEventListener('click', () => {
        this.togglePlayMobile(video, index);
      });

      if (window.innerWidth < 992) {
        this.playButton.addEventListener('click', () => {
          overlay.style.display = 'none';
          this.playMobileVideo(video, index);
        });
      }
    });

    this.desktopVideos.forEach((video, index) => {
      const container = video.closest('.video-container-desktop');
      const muteBtn = container.querySelector('.mute-btn');
      const unmuteBtn = container.querySelector('.unmute-btn');

      if (video.muted) {
        muteBtn.classList.remove('hidden');
        unmuteBtn.classList.add('hidden');
      } else {
        muteBtn.classList.add('hidden');
        unmuteBtn.classList.remove('hidden');
      }

      muteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleMuteDesktopForContainer(container);
      });
      unmuteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleMuteDesktopForContainer(container);
      });

      const overlay = container.querySelector('.video-overlay');
      const soundButtons = document.querySelectorAll('.sound-buttons');
      if (overlay) {
        overlay.addEventListener('click', () => {
          overlay.style.display = 'none';
          soundButtons.forEach((sb) => {
            sb.style.visibility = 'visible';
          });
          this.playDesktopVideo(video, index);
        });
      }

      video.addEventListener('click', () => {
        this.togglePlayDesktop(video, index);
      });

      if (window.innerWidth >= 992) {
        this.playButton.addEventListener('click', () => {
          overlay.style.display = 'none';
          this.playDesktopVideo(video, index);
        });
      }
    });
  }

  togglePlayMobile(video, index) {
    if (video.paused || video.ended) {
      this.playMobileVideo(video, index);
    } else {
      this.pauseMobileVideo(video, index);
    }
  }

  playMobileVideo(video, index) {
    this.mobileVideos.forEach((v, idx) => {
      if (v !== video) {
        v.pause();
        const otherOverlay = v.closest('.video-container-mobile').querySelector('.video-overlay');
        if (otherOverlay) {
          otherOverlay.style.display = 'block';
        }
      }
    });
    video.play();
    const thumbnail = document.querySelector('.video-container-mobile .video-thumbnail');
    if (thumbnail) {
      thumbnail.style.display = 'none';
    }
    const container = video.closest('.video-container-mobile');
    const overlay = container.querySelector('.video-overlay');
    const soundButtons = document.querySelectorAll('.sound-buttons');
    if (overlay) {
      overlay.style.display = 'none';
      soundButtons.forEach((sb) => {
        sb.style.visibility = 'visible';
      });
    }
    const vbc = document.querySelector('.video-button-container');
    if (vbc) {
      vbc.style.visibility = 'hidden';
    }
    if (this.headlineVideos.length > 0) {
      this.headlineVideos[0].style.display = 'none';
    }
  }

  pauseMobileVideo(video, index) {
    video.pause();
    const thumbnail = document.querySelector('.video-container-mobile .video-thumbnail');
    if (thumbnail) {
      thumbnail.style.display = 'block';
    }
    const container = video.closest('.video-container-mobile');
    const overlay = container.querySelector('.video-overlay');
    const soundButtons = document.querySelectorAll('.sound-buttons');
    if (overlay) {
      overlay.style.display = 'block';
      soundButtons.forEach((sb) => {
        sb.style.visibility = 'hidden';
      });
    }
    const vbc = document.querySelector('.video-button-container');
    if (vbc) {
      vbc.style.visibility = 'visible';
    }
    if (this.headlineVideos.length > 0) {
      this.headlineVideos[0].style.display = 'block';
    }
  }

  toggleMuteMobileForContainer(container) {
    const video = container.querySelector('.video-mobile');
    const muteBtn = container.querySelector('.mute-btn');
    const unmuteBtn = container.querySelector('.unmute-btn');
    if (video.muted) {
      video.muted = false;
      muteBtn.classList.add('hidden');
      unmuteBtn.classList.remove('hidden');
    } else {
      video.muted = true;
      muteBtn.classList.remove('hidden');
      unmuteBtn.classList.add('hidden');
    }
  }

  togglePlayDesktop(video, index) {
    if (video.paused || video.ended) {
      this.playDesktopVideo(video, index);
    } else {
      this.pauseDesktopVideo(video, index);
    }
  }

  playDesktopVideo(video, index) {
    this.desktopVideos.forEach((v, idx) => {
      if (v !== video) {
        v.pause();
        const otherOverlay = v.closest('.video-container-desktop').querySelector('.video-overlay');
        if (otherOverlay) {
          otherOverlay.style.display = 'block';
        }
      }
    });
    video.play();
    const thumbnail = document.querySelector('.video-container-desktop .video-thumbnail');
    if (thumbnail) {
      thumbnail.style.display = 'none';
    }
    const container = video.closest('.video-container-desktop');
    const overlay = container.querySelector('.video-overlay');
    const soundButtons = document.querySelectorAll('.sound-buttons');

    if (overlay) {
      overlay.style.display = 'none';
      soundButtons.forEach((sb) => {
        sb.style.visibility = 'visible';
      });
    }
    const vbc = document.querySelector('.video-button-container');
    if (vbc) {
      vbc.style.visibility = 'hidden';
    }
    if (this.headlineVideos.length > 0) {
      this.headlineVideos[0].style.display = 'none';
    }
  }

  pauseDesktopVideo(video, index) {
    video.pause();
    const thumbnail = document.querySelector('.video-container-desktop .video-thumbnail');
    if (thumbnail) {
      thumbnail.style.display = 'block';
    }
    const container = video.closest('.video-container-desktop');
    const overlay = container.querySelector('.video-overlay');
    const soundButtons = document.querySelectorAll('.sound-buttons');

    if (overlay) {
      overlay.style.display = 'block';
      soundButtons.forEach((sb) => {
        sb.style.visibility = 'hidden';
      });
    }
    const vbc = document.querySelector('.video-button-container');
    if (vbc) {
      vbc.style.visibility = 'visible';
    }
    if (this.headlineVideos.length > 0) {
      this.headlineVideos[0].style.display = 'block';
    }
  }

  toggleMuteDesktopForContainer(container) {
    const video = container.querySelector('.video-desktop');
    const muteBtn = container.querySelector('.mute-btn');
    const unmuteBtn = container.querySelector('.unmute-btn');
    if (video.muted) {
      muteBtn.classList.add('hidden');
      unmuteBtn.classList.remove('hidden');
      video.muted = false;
    } else {
      muteBtn.classList.remove('hidden');
      unmuteBtn.classList.add('hidden');
      video.muted = true;
    }
  }
}

const videoPlayer = new VideoPlayer(
  '.video-mobile',
  '.video-desktop',
  '.play-button',
  '.headline-video'
);
  
